module.exports = __webpack_public_path__ + "static/media/tent.7d55c899.png";